import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { WEDDING_BOUTIQUE },
} = NAV_DATA;

const getWeddingBoutique = (): MegaMenuNavItem => {
  const children = [
    {
      headline: 'Featured',
      children: [
        {
          title: 'New Arrivals',
          path: '/shop/collection/wedding-shop-new-arrivals',
        },
        {
          title: 'Brands',
          path: '/shop/brands/wedding-shop',
        },
        {
          title: 'Collections',
          path: '/shop/gift-collections/wedding-shop-collections',
        },
        {
          title: 'Face Masks',
          path: '/shop/collection/fashion-face-masks',
          newTag: true,
        },
        {
          title: 'The Monogram Shop',
          path: '/shop/collection/monogramming-shop',
          newTag: true,
        },
        {
          title: 'Wedding Boutique Exclusives',
          path: '/shop/collection/zola-exclusives1',
        },
        {
          title: 'Sale',
          path: '/shop/collection/wedding-boutique-sale',
          className: 'nav-link--red',
        },
      ],
    },
    {
      headline: 'Bridal',
      children: [
        {
          title: 'All Bridal',
          path: '/shop/category/bridal-boutique',
        },
        {
          title: 'Accessories',
          path: '/shop/category/wedding-shop-accessories',
        },
        {
          title: 'Jewelry',
          path: '/shop/category/wedding-jewelry',
        },
        {
          title: 'Shoes',
          path: '/shop/category/bridal-shoes',
        },
        {
          title: 'Intimates',
          path: '/shop/category/wedding-intimates',
        },
        {
          title: 'Shapewear',
          path: '/shop/category/bridal-slips-shapewear',
        },
      ],
    },
    {
      headline: 'Wedding Party',
      children: [
        {
          title: 'All Wedding Party',
          path: '/shop/category/wedding-party-attire',
        },
        {
          title: 'Bridesmaid Jewelry',
          path: '/shop/category/giftable-jewelry',
        },
        {
          title: 'Robes & Sleepwear',
          path: '/shop/category/lounge-wear',
        },
        {
          title: "Men's Accessories",
          path: '/shop/category/mens-wedding-accessories',
        },
        {
          title: 'Bach Party Gear',
          path: '/shop/category/bachparty-gear',
        },
        {
          title: 'Pet Accessories',
          path: '/shop/category/pets-accessories',
        },
      ],
    },
    {
      headline: 'Gifts & Favors',
      children: [
        {
          title: 'All Gifts & Favors',
          path: '/shop/category/wedding-gifts-favors',
        },
        {
          title: 'For the Ladies',
          path: '/shop/category/ladies-gifts',
        },
        {
          title: 'For the Gents',
          path: '/shop/category/gifts-for-the-gents',
        },
        {
          title: 'Wedding Party Gifts',
          path: '/shop/category/gifts-for-the-wedding-party',
        },
        {
          title: 'Party Favors',
          path: '/shop/category/favors',
        },
        {
          title: 'Sweets & Treats',
          path: '/shop/category/wedding-sweets-treats',
        },
        {
          title: 'Beauty & Wellness',
          path: '/shop/category/health-wellness',
        },
      ],
    },
    {
      headline: 'Party Decor',
      children: [
        {
          title: 'All Party Decor',
          path: '/shop/category/party-supplies-decor',
        },
        {
          title: 'Ceremony',
          path: '/shop/category/ceremony',
        },
        {
          title: 'Reception',
          path: '/shop/category/reception',
        },
        {
          title: 'Bridal Shower',
          path: '/shop/collection/for-the-bridal-shower2',
        },
        {
          title: 'Bachelorette Party',
          path: '/shop/collection/bachelorette-party',
        },
      ],
    },
  ];

  return {
    title: 'Boutique',
    id: WEDDING_BOUTIQUE,
    path: '/shop/category/wedding-shop',
    parent: 'WeddingBoutique',
    children,
  };
};

export default getWeddingBoutique;
